const basePath = resourceId => `recharges_whitelist/${resourceId}`

export default {
  /*
   * index() lista la lista blanca de recargas
   */
  index(params) {
    return Vue.http.get(basePath(''), {params}).then(response => response.data.data)
  }
}
